import React from 'react'
import styled from 'styled-components'
import HeaderGiving from '../Components/givingback/HeaderGiving'
import SectionGiving from '../Components/givingback/SectionGiving'
const GivingbBack = () => {
  return (
    <StyleGivingbBack>
        <HeaderGiving />
        <SectionGiving />
    </StyleGivingbBack>
  )
}
const StyleGivingbBack= styled.div`
`
export default GivingbBack